import {Component, Injector, OnInit} from '@angular/core';
import {DialogBaseComponent} from "../../admin-panel/base-admin-panel/dialog-base/dialog-base.component";
import { RaceViewModel } from "../Model/RaceViewModel";
import { RacesService } from "../../../services/races.service";

@Component({
    selector: '[app-race-devices-dialog]',
    templateUrl: './race-devices-dialog.component.html',
    styleUrls: ['./race-devices-dialog.component.css'],
    standalone: false
})

export class RaceDevicesDialogComponent extends DialogBaseComponent<RaceViewModel> implements OnInit {
  private racesService: RacesService;
  public isLoading: boolean = true;

  constructor(protected injector: Injector)
  {
    super(injector);
    this.racesService = injector.get(RacesService);
    this.dialogId = "editActivityDevices";
  }

  ngOnInit()
  {
    this.isLoading = true;
    this.racesService.getLinkedObjects(this.model.Id)
      .subscribe((res) => {
        this.objects = res;
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      });
  }

  public onToggleAll(value: boolean)
  {
    this.objects.forEach((command) =>
    {
      command.IsChecked = value;
    });
  }

  public onToggle(val: any)
  {
  }

  public submit()
  {
    this.racesService.updateLinkedObjects(this.model.Id, this.objects)
      .subscribe((res) =>
      {
        this.onCreated.emit();
        this.close();
        this.syncService.NotifyEntityChanged("Activity", this.model.Id);
        super.submit();
      });
  }

}
